var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-absolute-window-height-container',{ref:"itemsDiv",staticClass:"w-select-options",class:{roundedTop: _vm.roundedTop, roundedBottom: _vm.roundedBottom},attrs:{"up":_vm.up,"max-height":_vm.maxHeight}},[_c('w-scroll-view',{ref:"scroller"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }